import { BiLinkExternal } from "react-icons/bi";
const ReplaceUrlsWithLinks = (content) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;

  if (Array.isArray(content)) {
    return content.map((part, index) => {
      if (typeof part === "string") {
        return part.split(urlRegex).map((text, i) =>
          urlRegex.test(text) ? (
            <a
              key={i}
              href={text}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:text-blue-300 underline inline-flex items-center gap-0.5  transition-colors"
            >
              {text}
              <BiLinkExternal className="text-xs" />
            </a>
          ) : (
            text
          )
        );
      }
      return part;
    });
  } else if (typeof content === "string") {
    return content.split(urlRegex).map((part, index) =>
      urlRegex.test(part) ? (
        <a
          key={index}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          className="text-white underline inline-flex items-center gap-0.5 hover:text-blue-200 transition-colors"
        >
          {part}
          <BiLinkExternal className="text-xs" />
        </a>
      ) : (
        part
      )
    );
  }

  return content;
};

export default ReplaceUrlsWithLinks;
